import { useStore } from '@/store'
import SidebarReveal from './SidebarReveal'
import MainContent from './MainContent'

// Top-level two-column grid: collapsible sidebar on the left, main content on
// the right. Animation lives in SidebarReveal; this component just owns the
// grid template that responds to sidebar state.
export default function AppShell() {
  const sidebarOpen = useStore(s => s.sidebarOpen)
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: sidebarOpen ? 'var(--sidebar-w) 1fr' : '0px 1fr',
        height: '100vh',
        width: '100vw',
        overflow: 'hidden',
      }}
    >
      <SidebarReveal />
      <MainContent />
    </div>
  )
}